(()=>{
 const root=document.getElementById('myk-order-guide');if(!root||root.dataset.ready)return;root.dataset.ready='true';
 const translations=JSON.parse(root.querySelector('[data-guide-translations]').textContent);
 let locale=new URL(location.href).searchParams.get('order_review')==='ja'||root.dataset.guideLocale==='ja'?'ja':'en';
 const word=(key)=>translations[locale][key]||translations.en[key]||key;
 const nav=[...root.querySelectorAll('.quick-nav-links a')];
 function translate(){root.classList.toggle('ja',locale==='ja');root.lang=locale;for(const [attr,prefix]of [['data-t',''],['data-shop-t','shop_'],['data-ui-text','ui_'],['data-v13','hero_'],['data-guide-copy','label_']])root.querySelectorAll('['+attr+']').forEach(el=>el.textContent=word(prefix+el.getAttribute(attr)));root.querySelectorAll('[data-overview]').forEach(el=>el.textContent=word('o'+(Number(el.dataset.overview)+1)));}
 translate();

 // Keep short headings in meaningful phrases, without fixed screen-specific line breaks.
 const phraseGroups=[
 ['.hero h1',['From Japan.','Chosen for your business.']],
 ['#step-1 .step-text h3',['Try samples.','Find your matcha.']],
 ['#step-2 .step-text h3',['Order for your','café or brand']],
 ['.shop-heading h3',['MIYAKO MATCHA','Selection']],
 ['.support h2',['Need help','choosing your route?']]
 ];
 phraseGroups.forEach(([selector,groups])=>root.querySelectorAll(selector).forEach(el=>{
  if(el.textContent.trim()!==groups.join(' '))return;
  el.replaceChildren();
  groups.forEach((text,index)=>{if(index)el.append(document.createTextNode(' '));
   const phrase=document.createElement('span');phrase.className='guide-phrase';phrase.textContent=text;el.append(phrase);
  });
 }));


 const proof=root.querySelector('#brand-proof');
 const motion=matchMedia('(prefers-reduced-motion:reduce)');
 const counters=proof?[...proof.querySelectorAll('.proof-number>span')]:[];
 let rollingStarted=false;
 const rollingAnimations=[];
 function finishCounters(){rollingAnimations.forEach(a=>a.cancel());counters.forEach(el=>{el.textContent=el.dataset.finalCount||el.textContent;});}
 function rollCounters(){
  if(rollingStarted)return;rollingStarted=true;
  if(motion.matches||!Element.prototype.animate)return;
  counters.forEach(el=>{
   const target=el.textContent.trim();if(!/^\d+$/.test(target))return;el.dataset.finalCount=target;
   el.classList.add('proof-rolling-value');el.replaceChildren();
   [...target].forEach((digit,index)=>{
    const windowEl=document.createElement('span'),strip=document.createElement('span');
    windowEl.className='proof-digit-window';strip.className='proof-digit-strip';
    const end=20+Number(digit);
    for(let n=0;n<=end;n++){const cell=document.createElement('span');cell.textContent=String(n%10);strip.append(cell);}
    windowEl.append(strip);el.append(windowEl);
    const animation=strip.animate([{transform:'translateY(0)'},{transform:'translateY(-'+end+'em)'}],{duration:1000+index*110,easing:'cubic-bezier(.16,.72,.2,1)',fill:'forwards'});
    rollingAnimations.push(animation);
   });
  });
  setTimeout(finishCounters,1500);
 }
 if(proof){if('IntersectionObserver' in window){const counterObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){rollCounters();counterObserver.disconnect();}},{threshold:.35});counterObserver.observe(proof);}else rollCounters();}
 motion.addEventListener?.('change',event=>{if(event.matches)finishCounters();});

 const rail=root.querySelector('.brand-format-grid'),controls=root.querySelector('#packaging-rail-controls'),prev=root.querySelector('#packaging-prev'),next=root.querySelector('#packaging-next');
 function railState(){const over=rail.scrollWidth>rail.clientWidth+2;controls.hidden=!over;prev.disabled=rail.scrollLeft<=2;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;}
 function step(d){rail.scrollBy({left:d*(rail.querySelector('.brand-format').getBoundingClientRect().width+(parseFloat(getComputedStyle(rail).columnGap)||16)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}prev.addEventListener('click',()=>step(-1));next.addEventListener('click',()=>step(1));rail.addEventListener('scroll',railState,{passive:true});window.addEventListener('resize',railState);railState();
 function active(){let current=nav[0];for(const link of nav){const target=root.querySelector(link.hash);if(target&&target.getBoundingClientRect().top<220)current=link;}nav.forEach(link=>link===current?link.setAttribute('aria-current','location'):link.removeAttribute('aria-current'));}window.addEventListener('scroll',active,{passive:true});active();

 // Reveal each stage once; all content remains readable before animation.
 const stages=root.querySelector('.details-list');
 if(stages&&'IntersectionObserver' in window&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
   stages.querySelectorAll(':scope>li>.step-text>h3').forEach(heading=>{
     const text=heading.textContent;heading.setAttribute('aria-label',text);
     const phrases=[...heading.querySelectorAll('.guide-phrase')];let index=0;
     const containers=phrases.length?phrases:[heading];
     containers.forEach(container=>{
      const parts=container.textContent.match(/\S+|\s+/gu)||[container.textContent];
      container.replaceChildren();
      parts.forEach(part=>{if(/^\s+$/u.test(part)){container.append(document.createTextNode(part));return;}
       const word=document.createElement('span'),inner=document.createElement('span');
       word.className='myk-step-title-word';word.setAttribute('aria-hidden','true');
       inner.textContent=part;inner.style.setProperty('--title-delay',Math.min(index++*38,190)+'ms');
       word.append(inner);container.append(word);
      });
     });
   });
   stages.classList.add('has-step-motion');
   const stageObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-step-visible');stageObserver.unobserve(entry.target);}});},{threshold:0,rootMargin:'0px 0px -12% 0px'});
   stages.querySelectorAll(':scope>li[id]').forEach(stage=>stageObserver.observe(stage));
 }


 // Decorative lines; merchant requested no visible playback controls.
 root.querySelectorAll('.details-list>li>.step-mark').forEach(mark=>{
  const line=document.createElement('span');line.className='guide-step-line';line.setAttribute('aria-hidden','true');mark.append(line);
 });

 const toast=root.querySelector('.guide-cart-toast'),message=root.querySelector('[data-guide-message]');let toastTimer;
 root.querySelector('[data-guide-dismiss]').addEventListener('click',()=>{toast.hidden=true});
 function announce(text){message.textContent=text;toast.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>{if(!toast.contains(document.activeElement)&&!toast.matches(':hover'))toast.hidden=true},6500);}
 const base=window.Shopify?.routes?.root||'/';
 root.addEventListener('submit',async(event)=>{
  const form=event.target.closest('.myk-guide-add-form');if(!form)return;event.preventDefault();if(form.dataset.pending)return;
  const button=form.querySelector('button');if(button.disabled)return;form.dataset.pending='true';button.disabled=true;button.setAttribute('aria-busy','true');
  try{
   const data=new FormData(form);data.set('quantity','1');data.set('sections','cart-icon-bubble');data.set('sections_url',location.pathname);
   const url=new URL(root.dataset.addUrl,location.origin);if(!url.pathname.endsWith('.js'))url.pathname+='.js';
   const response=await fetch(url,{method:'POST',body:data,credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
   const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||word('label_add_error'));
   toast.hidden=true;
   clearTimeout(button._guideCheckTimer);
   button.dataset.addLabel ||= button.getAttribute('aria-label');
   button.querySelector('.guide-check').hidden=false;
   button.classList.remove('is-guide-added');void button.offsetWidth;button.classList.add('is-guide-added');
   button.setAttribute('aria-label',word('label_added')+': '+(result.product_title||result.title||''));
   button._guideCheckTimer=setTimeout(()=>{button.querySelector('.guide-check').hidden=true;button.classList.remove('is-guide-added');button.setAttribute('aria-label',button.dataset.addLabel);},1500);
   if(result.sections?.['cart-icon-bubble']){const doc=new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html');const source=doc.querySelector('#cart-icon-bubble')||doc.querySelector('.shopify-section');const current=document.querySelector('#cart-icon-bubble');if(current&&source)current.innerHTML=source.innerHTML;}
   try{const cart=await fetch(base+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(r=>r.json());root.querySelectorAll('[data-guide-cart-count]').forEach(el=>el.textContent=String(cart.item_count));}catch(error){}

  }catch(error){announce(error.message||word('label_add_error'));}
  finally{delete form.dataset.pending;button.disabled=false;button.removeAttribute('aria-busy');}
 });
})();
